import React from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {getBidContacts, removeBidContact} from "../../actions/bidcontacts";
import {codeProjection} from "../../projections";
import ContactSearch from "../Boilerplate/ContactSearch";
import {RoutedTabsFactory} from "../Boilerplate/RoutedTabs";
import {Route, Switch} from "react-router";
import {ContactsView} from "../Boilerplate/ContactsView";
import {Button, Card, Icon, Tooltip} from "antd";
import {clearUserSearch, getUsersQuery} from "../../actions/users";
import {currentEffectiveUserId, searchState} from "../../reducers/ui";
import {CodeTag} from "../Boilerplate/CodeTag";
import {inviteUser, inviteUserContactLists, inviteUserEmails, updateBidInvitePermissions} from "../../actions/bids";
import {createSelector} from "reselect/es"; // fix for Webstorm IDE code analysis
import * as R from 'ramda';
import {CodeSingleSelect} from "../Boilerplate/CodeSingleSelect";
import {codeTables} from "../../codes";
import {getMyCompany} from "../../actions/companies";
import SearchBox from "../Boilerplate/SearchBox";
import {canUpdate} from "../Boilerplate/permissions";

class BidContacts extends React.PureComponent {
  state = { searchTerm: null };

  getTabs = () => {
    const {company} = this.props;

    let injectedTabs = [];

    const tab = this.props.location.pathname.split('/').filter(i => i).slice(-1);

    switch (tab && tab[0]) {
      case 'bidding':
        injectedTabs = [
          {
            key: 'bidding',
            text: 'Contacts Bidding',
            dest: params => `/bids/${params.bidId}/contacts/bidding`,
            selected: { path: `/bids/:bidId/contacts/bidding` }
          }
        ];
        break;
      case 'notbidding':
        injectedTabs = [
          {
            key: 'notbidding',
            text: 'Contacts Not Bidding',
            dest: params => `/bids/${params.bidId}/contacts/notbidding`,
            selected: { path: `/bids/:bidId/contacts/notbidding` }
          }
        ];
        break;
      case 'undecided':
        injectedTabs = [
          {
            key: 'undecided',
            text: 'Contacts Undecided',
            dest: params => `/bids/${params.bidId}/contacts/undecided`,
            selected: { path: `/bids/:bidId/contacts/undecided` }
          }
        ];
        break;
    }

    return [
      {
        key: 'mycompany',
        text: company ? company.companyname : 'Loading...',
        dest: params => `/bids/${params.bidId}/contacts/mycompany`,
        selected: { path: `/bids/:bidId/contacts/mycompany` }
      },
      {
        key: 'all',
        text: 'Bid Contacts',
        dest: params => `/bids/${params.bidId}/contacts/`,
        selected: { path: `/bids/:bidId/contacts/`, exact: true }
      },
      ...injectedTabs,
      {
        key: 'planholders',
        text: 'Plan Holders',
        dest: params => `/bids/${params.bidId}/contacts/planholders`,
        selected: { path: `/bids/:bidId/contacts/planholders` }
      },
      {
        key: 'email',
        text: 'Email Invites',
        dest: params => `/bids/${params.bidId}/contacts/email`,
        selected: { path: `/bids/:bidId/contacts/email` }
      },
    ];

  };

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  handleSearch = searchTerm => {
    this.setState({ searchTerm });
  };

  extras = (handleInvite, onDelete) => (contact) => {
    if (contact['status']) {
      return <CodeTag table='bidinvitestatus' code={contact.status}/>
    } else {
      return <Button onClick={() => handleInvite(contact)}>Invite</Button>
    }
  };

  render() {
    const { bid, searchResults, searchState, onNewInvites, onSearch, onInvite, onSearchMount, onEmailInvite, onContactListInvite, cache = {} } = this.props;
    const { searchTerm = null } = this.state;
    const extras = canUpdate(bid) && this.extras;
    const BidContactsNavBar = RoutedTabsFactory(this.getTabs(), 'all', { type: 'card' });
    const contactCount = cache.size ?
      <strong>{cache.size}</strong> :
      <React.Fragment><Icon type={'loading'}/> loading...</React.Fragment>;
    return (
      <div>
        {/*<Row gutter={24} align='top'>*/}
        {/*<Col xs={24} lg={17}>*/}
        <Switch>
          <Route exact path='/bids/:bidId/contacts/new' render={props => (
            <React.Fragment>
              <ContactSearch
                searchState={searchState}
                searchResults={searchResults}
                onBack={() => props.history.goBack()}
                onMount={onSearchMount}
                onSearch={onSearch}
                onInvite={onInvite}
                onEmailInvite={onEmailInvite}
                onContactListInvite={onContactListInvite}
                extras={extras}
              />
            </React.Fragment>
          )}/>
          <Route render={props => (
            <React.Fragment>
              <Card
                title={<BidContactsNavBar/>}
                extra={canUpdate(bid) && <React.Fragment>
                  <Button icon='user-add' onClick={onNewInvites}>New Invites</Button>
                </React.Fragment>}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 15 }}>
                  <span>Total contacts across all tabs: {contactCount}</span>
                  <SearchBox
                    placeholder="Search tabs by name, company, email, phone, city, or state"
                    onChange={this.handleSearch}
                    className='contact-search control-search'
                    interactive
                  />
                </div>
                {
                  searchTerm ?
                    <React.Fragment>
                      <SearchBidContacts searchTerm={searchTerm} match={this.props.match}/>
                    </React.Fragment> :
                    <React.Fragment>
                      <Route exact path='/bids/:bidId/contacts/' component={AllBidContacts}/>
                      <Route path='/bids/:bidId/contacts/bidding' component={BidStatusAcceptedContacts}/>
                      <Route path='/bids/:bidId/contacts/notbidding' component={BidStatusDeclinedContacts}/>
                      <Route path='/bids/:bidId/contacts/undecided' component={BidStatusPendingContacts}/>
                      <Route path='/bids/:bidId/contacts/mycompany' component={MyCompanyBidContacts}/>
                      <Route path='/bids/:bidId/contacts/planholders' component={PlanHolderBidInvites}/>
                      <Route path='/bids/:bidId/contacts/email' component={EmailBidInvites}/>
                    </React.Fragment>
                }
              </Card>
            </React.Fragment>
          )}/>
        </Switch>
      </div>
    );
  }
}

const getProfile = state => R.view(R.lensPath(['profile']), state);

const _getMyCompany = createSelector(
  getProfile,
  state => state.companies,
  (profile, companies) => R.path(['data', profile.companyid, 'resource'], companies)
);

const getCurrentBidId = (state, props) => props.match.params.bidId;

const getContactsCache = createSelector(
  getCurrentBidId,
  state => R.path(['bidcontacts','data'], state),
  (bidId, bidContacts) => R.path([bidId, 'cache'], bidContacts)
);

const getCurrentBid = createSelector(
  getCurrentBidId,
  state => state.view,
  (bidId, view) => R.path(['data', bidId], view)
);

const getCurrentBidPermissions = createSelector(
  getCurrentBid,
  (bid) => bid.permissions
);

const getCurrentBidContactList = createSelector(
  getCurrentBidId,
  state => state.bidcontacts,
  (bidId, bidcontacts) => bidcontacts.data[bidId]
);

const getCurrentBidOwners = createSelector(
  getCurrentBid,
  ({resource: {createdbyuserid, owneruserid}}) => [createdbyuserid, owneruserid]
);

const mergedContacts = createSelector(
  getCurrentBidContactList,
  state => state.ui.userSearchResults,
  (bidContacts, searchContacts) => {
    bidContacts = bidContacts || {};
    return searchContacts.map(id => {
      if (bidContacts[id])
        return bidContacts[id];
      else
        return { contactuserid: id };
    });
  }
);

const _getAllContacts = createSelector(
  getCurrentBidContactList,
  (list) => {
    if (!list) return [];
    list = Object.values(list);
    return list;
  }
);

const searchContacts = createSelector(
  _getAllContacts,
  state => state.companies,
  (state, props) => new RegExp(props.searchTerm, 'i'),
  (list, companies, search) => list.filter(contact => {
    const company = R.path(['data', contact.companyid, 'resource'], companies) || {};
    // Extract searchable fields from user object and user company object
    const obj = (
      ({ firstname, lastname, title, email, phone, cell, fax, company: { companyname, address, address2, city, state, zip } }
      ) => ({ firstname, lastname, title, email, phone, cell, fax, companyname, address, address2, city, state, zip })
    )({ ...contact, company });
    return Object.values(obj)
      .map(i => search.test(i)) // Test search term against each field
      .filter(i => i).length; // Grab only results with one or more match
  })
);

const getAllContacts = createSelector(
  _getAllContacts,
  (list) => list.filter(contact => contact.userinitialized)
);

const statusBidAcceptedContacts = createSelector(
  _getAllContacts,
  list => list.filter(contact => contact.status === 'accepted')
);

const statusBidDeclinedContacts = createSelector(
  _getAllContacts,
  list => list.filter(contact => contact.status === 'declined')
);

const statusBidPendingContacts = createSelector(
  _getAllContacts,
  list => list.filter(contact => contact.status === 'pending')
);

const getMyCompanyContacts = createSelector(
  _getAllContacts,
  getProfile,
  (list, profile) => list.filter((
    contact => contact.companyid === profile.companyid
  ))
);

const getPlanHolderInvites = createSelector(
  _getAllContacts,
  (list) => list.filter(contact => contact.viewed)
);

const getEmailInvites = createSelector(
  _getAllContacts,
  (list) => list.filter(contact => contact.hasOwnProperty('userinitialized') && !contact.userinitialized)
);

const mapCodes = (list, state) => list.map(codeProjection(['status'], codeTables.get('bidinvitestatus')));

const mapDispatchMaster = (dispatch, props) => {
  const {
    match: {
      params: { bidId }
    },
    history
  } = props;
  return {
    onMount: () => {
      dispatch(getMyCompany());
      return dispatch(getBidContacts(bidId));
    },
    onSearchMount: () => dispatch(clearUserSearch()),
    onNewInvites: () => history.push(`/bids/${bidId}/contacts/new`),
    onSearch: (value) => dispatch(getUsersQuery(value)),
    onInvite: (contact) => dispatch(inviteUser(bidId, contact.contactuserid)),
    onEmailInvite: (emails) => dispatch(inviteUserEmails(bidId, emails)),
    onContactListInvite: (contactlists) => dispatch(inviteUserContactLists(bidId, contactlists)),
  };
};

const mapDispatchTabs = (dispatch, props) => {
  const {
    match: {
      params: { bidId }
    },
    history
  } = props;
  return {
    onSearch: (value) => dispatch(getUsersQuery(value)),
    onInvite: (contact) => dispatch(inviteUser(bidId, contact.contactuserid)),
    onEmailInvite: (emails) => dispatch(inviteUserEmails(bidId, emails)),
    onContactListInvite: (contactlists) => dispatch(inviteUserContactLists(bidId, contactlists)),
    path: ['bidcontacts', 'data', bidId],
  };
};

// const _codes = codes;
const _BidCardExtras = ({ contact, currentUser, permissions, onDelete, onChangeRole, owners, myCompany }) => (
  <React.Fragment>
    {
      contact.userinitialized &&
      <CodeSingleSelect
        allowClear size='small'
        style={{ width: 100 }}
        codes={codeTables.get('bidrole')}
        value={contact.role}
        onChange={onChangeRole}
        disabled={!(permissions.update && !owners.includes(contact.contactuserid) && contact.contactuserid !== currentUser)}
      />
    }
    {
      !(owners.includes(contact.contactuserid))
        ? <React.Fragment>
          {contact.userinitialized && contact.status && !myCompany.includes(contact.contactuserid) &&
          <CodeTag table='bidinvitestatus' code={contact.status}/>}
          {currentUser !== contact.contactuserid &&
          <Tooltip title={'Remove user from bid'}><Button size='small' icon='user-delete' onClick={onDelete}/></Tooltip>}
        </React.Fragment>
        : null
    }
  </React.Fragment>
);

const BidCardExtras = connect(
  (state, props) => ({
    currentUser: currentEffectiveUserId(state),
    owners: getCurrentBidOwners(state, props),
    myCompany: getMyCompanyContacts(state, props).map(contact => contact.contactuserid),
    permissions: getCurrentBidPermissions(state, props),
  }),
  (dispatch, props) => ({
    onDelete: () => dispatch(removeBidContact(props.contact.bidid, props.contact.contactuserid)),
    onChangeRole: (role) => dispatch(updateBidInvitePermissions(props.contact.bidid, props.contact.contactuserid, role || null))
  })
)(_BidCardExtras);

const getContacts = filterContacts => compose(
  connect(
    (state, props) => {
      let list = filterContacts(state, props);
      list = mapCodes(list, state);
      let bidId = getCurrentBidId(state, props);
      let bid = getCurrentBid(state, props);
      return {
        contacts: list,
        cache: getContactsCache(state, props),
        extras: contact => canUpdate(bid) && <BidCardExtras {...props} contact={contact} bidId={bidId}/>,
      };
    },
    mapDispatchTabs
  ),
)(ContactsView);

const SearchBidContacts = getContacts(searchContacts);
const AllBidContacts = getContacts(getAllContacts);
const BidStatusAcceptedContacts = getContacts(statusBidAcceptedContacts);
const BidStatusDeclinedContacts = getContacts(statusBidDeclinedContacts);
const BidStatusPendingContacts = getContacts(statusBidPendingContacts);
const MyCompanyBidContacts = getContacts(getMyCompanyContacts);
const PlanHolderBidInvites = getContacts(getPlanHolderInvites);
const EmailBidInvites = getContacts(getEmailInvites);

export default connect(
  (state, props) => ({
    bidId: getCurrentBidId(state, props),
    bid: getCurrentBid(state, props),
    profile: getProfile(state),
    company: _getMyCompany(state),
    cache: getContactsCache(state, props),
    searchResults: mergedContacts(state, props),
    searchState: searchState(state, props),
  }),
  mapDispatchMaster
)(BidContacts);



// WEBPACK FOOTER //
// ./src/components/Bids/BidContacts.js